import Layout from "./Layout";
import RequestRibbonFG from "../components/RequestRibbonFG.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function RequestMaterialPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <RequestRibbonFG></RequestRibbonFG>
        </Layout>
      )}
      {/* Add a loader or handle unauthorized access */}
    </>
  );
}

export default RequestMaterialPage;
